module.exports = __webpack_public_path__ + "static/media/6-th.714c9aa.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/6-th.wav
// module id = 8Ren
// module chunks = 1